import styled from 'styled-components';
import InfoTooltipWithIcon from '../../../../../../generic/components/tooltips/info-tooltip-with-icon';
import { getTitleStyle } from '../../../../../../generic/content/texts/bou-title/title-style';
import { useIsTeam } from '../../../../../../generic/hooks';
import { BouSpacingLevel, fluidSpacing } from '../../../../../../generic/layout/bou-spacing';
import { DesktopOnly } from '../../../../../../generic/layout/breakpoint-utils';
import { bouToolCommonBoxPadding } from '../../../../../../generic/layout/layout-constants';
import { useImpactChartContext } from '../context';
import { ContributingArticlesCount } from './contributing-articles-count';
import { TooltipContent } from './shared';

export function MainTitleRow() {
  const { title: customTitle, staticMode, hideTitle, contributingArticlesCount, bigFonts } = useImpactChartContext();
  const title = customTitle ? customTitle : 'Net impact profile';

  const showContributingArticles = useIsTeam() && contributingArticlesCount !== undefined;

  if (hideTitle) {
    return <></>;
  }

  const TitleComp = bigFonts ? BigTitle : Title;

  return (
    <Root>
      <TitleWrap>
        <TitleComp>{title}</TitleComp>
        {!staticMode && (
          <InfoTooltipWithIcon content={<TooltipContent />} style={{ paddingLeft: '0.7em', fontSize: '1.2em' }} />
        )}
      </TitleWrap>
      {showContributingArticles && (
        <DesktopOnly>
          <ContributingArticlesCount />
        </DesktopOnly>
      )}
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${bouToolCommonBoxPadding};
  ${fluidSpacing('margin-bottom', BouSpacingLevel.TINY)};
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.h5`
  ${getTitleStyle({ size: 'h5' })}
`;

const BigTitle = styled.h5`
  ${getTitleStyle({ size: 'h3' })}
  margin-bottom: 20px;
`;
